import { createTrackingUtils } from "../index.js";
import useProfiler from "../../../hooks/useProfiler.js";
import { useEffect } from "react";
export const flights_funnel_dsa_condense_banner_mobile = createTrackingUtils({
    name: "flights_funnel_dsa_condense_banner_mobile",
    defaultStage: 1,
    stages: {
        main: 1,
        solo: 2,
        nonSolo: 3,
        longHaul: 4,
        weekend: 5,
        family: 6
    },
    goals: {
        click: 1
    },
    goalsWithValue: []
});
export const useTrackDSACondenseBannerMobile = (canTrack) => {
    const { isSolo, isLongHaul, isWeekendStay, isFamily } = useProfiler();
    useEffect(() => {
        if (!canTrack)
            return;
        if (isSolo())
            flights_funnel_dsa_condense_banner_mobile.stages.solo();
        if (!isSolo())
            flights_funnel_dsa_condense_banner_mobile.stages.nonSolo();
        if (isLongHaul())
            flights_funnel_dsa_condense_banner_mobile.stages.longHaul();
        if (isWeekendStay())
            flights_funnel_dsa_condense_banner_mobile.stages.weekend();
        if (isFamily())
            flights_funnel_dsa_condense_banner_mobile.stages.family();
    }, [isSolo, isLongHaul, isWeekendStay, isFamily, canTrack]);
};
